// src/api/AuthAPI.js
import apiClient from "./apiClient"; // no token needed
import { ENDPOINTS } from "./endpoints";
import apiAuthClient from "./apiAuthClient";

export const AuthAPI = {
  login: (data) => apiClient.post(ENDPOINTS.NOAUTH.LOGIN, data),

  signup: (data) => apiClient.post(ENDPOINTS.NOAUTH.signin, data),

  //mobile
  sendOtpToMobile: (phone) => apiClient.post("/send-otp-to-mobile", { phone }),
  verifyOtpToMobile: (phone, otp) =>
    apiClient.post("/verify-otp-to-mobile", { phone, otp }),

  /////profile
  getMyDetails: () => apiAuthClient.get(ENDPOINTS.AUTH.GET_MY_DETAILS),
  updateCandidateDetails: (payload) =>
    apiAuthClient.put(ENDPOINTS.AUTH.UPDATE_CANDIDATE_DETAILS, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  changePassword: (data) =>
    apiAuthClient.put(ENDPOINTS.AUTH.CHANGE_PASSWORD, data),

  //firsttimeorder
  getfirsttimeorder: () => apiClient.get(ENDPOINTS.NOAUTH.getfirsttimeorder),
  getfirsttimeorder1: () =>
    apiAuthClient.get(ENDPOINTS.NOAUTH.getfirsttimeorder),

  //categories
  getcategories: (params) =>
    apiClient.get(ENDPOINTS.AUTH.getcategories, { params }),

  //products
  getproducts: (params) =>
    apiClient.get("/all-products", {
      params,
    }),
  getsingleproduct: (id) =>
    apiClient.get(ENDPOINTS.AUTH.getsingleproductss(id)),

  //address
  createaddress: (data) =>
    apiAuthClient.post(ENDPOINTS.AUTH.createaddres, data),
  getaddress: (params) =>
    apiAuthClient.get(ENDPOINTS.AUTH.getaddress, { params }),

  getsignleadress: (id) =>
    apiAuthClient.get(ENDPOINTS.AUTH.getsignleaddress(id)),
  updateaddress: (id, data) =>
    apiAuthClient.put(ENDPOINTS.AUTH.updateaddress(id), data),
  deleteaddress: (id) => apiAuthClient.delete(ENDPOINTS.AUTH.deleteaddress(id)),

  //cart
  withoulogincart: (data) => apiClient.post(ENDPOINTS.AUTH.withoutlogin, data),
  withlogincart: (data) => apiAuthClient.post(ENDPOINTS.AUTH.withlogin, data),
  // afterlogincart:()=>apiAuthClient.get(ENDPOINTS.AUTH.afterlogin),
  afterlogincart: (config = {}) =>
    apiAuthClient.get(ENDPOINTS.AUTH.afterlogin, config),
  // addtocart: (data) => apiAuthClient.post(ENDPOINTS.AUTH.addtocar, data),
  addtocart: (data, config = {}) =>
    apiAuthClient.post(ENDPOINTS.AUTH.addtocar, data, config),
  updatecart: (id, data) =>
    apiAuthClient.put(ENDPOINTS.AUTH.updatecart(id), data),
  deletecart: (id) => apiAuthClient.delete(ENDPOINTS.AUTH.deletecart(id)),
  syncCart: (data) => apiAuthClient.post(ENDPOINTS.AUTH.withlogin, data),
  checkoutPreview: () => apiAuthClient.post(ENDPOINTS.NOAUTH.checkpreview),

  //blog
  getAllBlogs: (params) => apiClient.get("/all-blogs", { params }),

  getSingleBlog: (id) => apiClient.get(`/single-blog/${id}`),

  createBlogReview: (payload) =>
    apiAuthClient.post("/add-blog-review", payload),

  //createorder
  createorder: (data) => apiAuthClient.post(ENDPOINTS.AUTH.createorder, data),
  
 createCodOrder: (data) => apiAuthClient.post(ENDPOINTS.AUTH.createCodOrder, data),

  verifypayment: (data) =>
    apiAuthClient.post(ENDPOINTS.AUTH.verifypayment, data),

  //purchasehistory
  getallpurchase: (params) =>
    apiAuthClient.get(ENDPOINTS.AUTH.getpurchaseorder, { params }),


    getallpayments: (params) =>
    apiAuthClient.get(ENDPOINTS.AUTH.getpayments, { params }),

  getsiglepurchaseorder: (id) =>
    apiAuthClient.get(ENDPOINTS.AUTH.getsignlepurchaseorder(id)),

  // forgot password
  otp: (data) => apiClient.post(ENDPOINTS.NOAUTH.otp, data),
  verityotp: (data) => apiClient.post(ENDPOINTS.NOAUTH.verifyotp, data),
  reset: (data) => apiClient.post(ENDPOINTS.NOAUTH.rest, data),

  //contactus
  createcontantus: (data) =>
    apiClient.post(ENDPOINTS.NOAUTH.createcontactus, data),

  //dashboard
  dashboard: () => apiAuthClient.get(ENDPOINTS.AUTH.dashboard),

  //reviews
  // getReviews: (productId) => apiAuthClient.get(`/product-reviews/${productId}`),


  getReviews: (
  productId,
  page = 1,
  limit = 5
) =>
  apiClient.get(
    `/product-reviews/${productId}?page=${page}&limit=${limit}`
  ),

  createReview: (payload) => apiAuthClient.post("/add-review", payload),
};
